// Vendor imports
const _ = require('lodash')
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Browser-only vendor imports
let Masonry
if (typeof window === 'object') {
  Masonry = require('masonry-layout')
}
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { FeedItemRecord } = require('client-v2/common/containers/feed/records')
const ArticleCard = require('client-v2/common/components/cards/article')

// BEM Block entity definition
const bem = BemEntity('ArticleProfileRelated')

function ArticleProfileRelated(props) {
  const blockRef = React.useRef()
  if (!props.items || !props.items.length) {
    return null
  }
  return (
    tag('section', {
      ref: blockRef,
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag(Heading, props),
      tag(Grid, {
        ...props,
        portalContainer: blockRef
      })
    )
  )
}

ArticleProfileRelated.propTypes = {
  // Values
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape(FeedItemRecord.propTypes)
  )
}

// Callback propTypes
const callbackKeys = [
  'onAddClick',
  'onCardClick',
  'onCountClick',
  'onDomainClick',
  'onMoreClick',
  'onPreviewClick',
  'onSeen',
  'onShareClick'
]
callbackKeys.forEach(key => {
  ArticleProfileRelated.propTypes[key] = PropTypes.func.isRequired
})

module.exports = ArticleProfileRelated

// Block element components

function Heading() {
  return (
    tag('div', {
      className: bem.element('heading')
    },
      'Related Posts'
    )
  )
}

function Grid(props) {
  const { items } = props
  const callbacks = _.pick(props, callbackKeys)

  const ref = React.useRef(null)
  if (Masonry) {
    React.useEffect(() => {
      const masonry = new Masonry(ref.current, {
        itemSelector: bem.elementSelector('grid-item'),
        percentPosition: true
      })

      return () => {
        masonry.destroy()
      }
    }, [items])
  }

  return (
    tag('div', {
      ref,
      className: bem.element('grid')
    },
      items.map(item => (
        tag(ArticleCard, {
          key: `related-item:${item.id}`,
          className: bem.element('grid-item'),
          article: item.article,
          pageContext: item.pageContext,
          portalContainer: props.portalContainer,
          ...callbacks
        })
      ))
    )
  )
}
